var matches = require('matches-selector')

module.exports = function (element, selector, checkYoSelf) {
  var parent = checkYoSelf ? element : element.parentNode

  while (parent && parent !== document) {
    if (matches(parent, selector)) return parent;
    parent = parent.parentNode
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/closest/index.js
// module id = 1427
// module chunks = 2